export const reloadPage = () => {
  window.location.href = window.location.href + "";
};
